import { gql, useQuery } from "utils/urql";
import { HomepageUpperBeltQuery } from "types/api";
import Image from "components/Image";
import styles from "./UpperBelt.module.scss";
import HomepageMetadata from "./HomepageMetadata";
import Caption from "./Caption";

const query = gql`
  fragment homepageUpperBeltAuthor on Author {
    id
    url
    displayName
  }

  query HomepageUpperBelt {
    homepageModule(slug: "upper-belt", version: "b1") {
      ... on HomepagePromoItemList {
        items {
          id
          url
          title
          dek
          kicker
          kickerUrl
          squareImage: riverImage(
            width: 86
            height: 86
            sizes: ["86w", "172w"]
          ) {
            url
            width
            height
            srcSet
            altText
            attributionText
            attributionUrl
          }
          wideImage: riverImage(
            width: 296
            height: 167
            sizes: ["291w", "296w", "455w", "582w", "592w", "910w"]
          ) {
            srcSet
          }
          authors {
            ...homepageUpperBeltAuthor
          }
        }
      }
    }
  }
`;

const UpperBelt = () => {
  const [{ data }] = useQuery<HomepageUpperBeltQuery>({ query });

  if (!data || data.homepageModule?.__typename !== "HomepagePromoItemList")
    return null;

  const articles = data.homepageModule?.items;

  return (
    <ul className={styles.list}>
      {articles.map((article, idx) => (
        <li className={styles.listItem} key={article.id}>
          <article className={styles.article}>
            {article.squareImage && (
              <figure className={styles.figure}>
                <a
                  data-action={`click link - upper belt - image ${idx + 1}`}
                  href={article.url}
                >
                  <picture>
                    {article.wideImage && (
                      <source
                        media="(min-width: 576px)"
                        srcSet={article.wideImage.srcSet}
                        sizes="(min-width: 1296px) 296px, (min-width: 976px) calc(25vw - 32px), calc(50vw - 32px)"
                      ></source>
                    )}
                    <Image
                      lazy={true}
                      className={styles.image}
                      src={article.squareImage.url}
                      srcSet={article.squareImage.srcSet}
                      alt={article.squareImage.altText}
                      width={article.squareImage.width}
                      height={article.squareImage.height}
                      sizes="86px"
                    />
                  </picture>
                </a>
                <div className={styles.hideOnMobile}>
                  <Caption
                    attributionText={article.squareImage.attributionText}
                    attributionUrl={article.squareImage.attributionUrl}
                  />
                </div>
              </figure>
            )}

            <div className={styles.info}>
              <h1 className={styles.title}>
                <a
                  className={styles.titleLink}
                  dangerouslySetInnerHTML={{ __html: article.title }}
                  data-action={`click link - upper belt - title ${idx + 1}`}
                  href={article.url}
                ></a>
              </h1>

              {article.dek && (
                <p
                  className={styles.dek}
                  dangerouslySetInnerHTML={{ __html: article.dek }}
                ></p>
              )}

              <HomepageMetadata
                authors={article.authors}
                analyticsSection="upper belt"
                riverIndex={idx + 1}
              />
            </div>
          </article>
        </li>
      ))}
    </ul>
  );
};

export default UpperBelt;
